import { CustomLayout } from '../../base_device'
import list_icon from '@/assets/img/device/mg75/list_icon.png'
import { Polar75 } from '../polar75'
import { KK } from '@/define/define'

export class Mg75 extends Polar75 {
  name: string = 'MG75'
  icon: string = list_icon
  width: number = 614
  fnDisableKeys: KK[] = [
    0x16, 0x3a, 0x3b, 0x3c, 0x3d, 0x3e, 0x3f, 0x40, 0x41, 0x42, 0x43, 0x44, 0x45,

    0xe3, 0x52, 0x50, 0x51, 0x4f, 0xe4,

    0xe6,

    0x2f, 0x30, 0x2a,
  ]

  customLayout: CustomLayout = {
    0x3a: this.createSquare(8),
    0x3e: this.createSquare(6),
    0x42: this.createSquare(6),
    0x46: this.createSquare(6),

    0x35: this.createSquare(2, this.y_number),
    0x1e: this.createSquare(2, this.y_number),
    0x1f: this.createSquare(2, this.y_number),
    0x20: this.createSquare(2, this.y_number),
    0x21: this.createSquare(2, this.y_number),
    0x22: this.createSquare(2, this.y_number),
    0x23: this.createSquare(2, this.y_number),
    0x24: this.createSquare(2, this.y_number),
    0x25: this.createSquare(2, this.y_number),
    0x26: this.createSquare(2, this.y_number),
    0x27: this.createSquare(2, this.y_number),
    0x2d: this.createSquare(2, this.y_number),
    0x2e: this.createSquare(2, this.y_number),
    0x2a: this.createSquare(2, this.y_number, 55),
    0x49: this.createSquare(2, this.y_number),

    0x2b: this.createSquare(2, 2, 47),
    0x31: this.createSquare(2, 2, 44.5),
    0x39: this.createSquare(2, 2, 48),
    0x28: this.createSquare(2, 2, 82),
    0xe1: this.createSquare(2, 2, 70),
    0xe5: this.createSquare(2, 2, 61),
    0xe0: this.createSquare(2, 2, 52),
    0xe2: this.createSquare(2, 2, 52),
    0xe3: this.createSquare(2, 2, 52),
    0x2c: this.createSquare(2, 2, 194),
    0xe6: this.createSquare(2, 2, 52),
    0x01: this.createSquare(2, 2, 52),
    0x50: this.createSquare(19, 2),
  }
}
